<div mat-dialog-title>Abteil ändern</div>
<div mat-dialog-content>
    <p>Abteil für {{ data.length }} Tier(e) ändern.</p>
    <mat-form-field>
        <mat-label>Abteil</mat-label>
        <input matInput [formControl]="abteilCtrl" />
    </mat-form-field>
</div>
<div mat-dialog-actions style="display: flex; justify-content: space-between; width: 100%">
    <button mat-raised-button color="primary" (click)="save()">Speichern</button>
    <button mat-button (click)="dialogRef.close()">Schlie&szlig;en</button>
</div>
